exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results[data-v-2427203a]{display:flex;flex-direction:row}.resultsInfo[data-v-2427203a]{flex-grow:1}.controls[data-v-2427203a]{margin-top:30px;margin-left:50px;min-width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2427203a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Results.vue
// module id = 46
// module chunks = 0